package floris.graphics.models.dto.requests.category

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class UpdateCategory(
    val name: String? = null,
    @SerialName("parent_category_id")
    val parentCategoryId: String? = null
) {
    // With the update, both the name and the parentCategoryId can be null, depending on which the user wants to update.
    val isValid get() = name.isNullOrBlank().not() || parentCategoryId != null

}